<template>
  <div class="main-contain">
    <div class="module-title main-title-text">实时运行参数</div>
    <div class="table-box">
      <dv-scroll-board
        class="table"
        :config="config"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: [
          '<span style="color:#08CDF8;"></span>',
          '<span style="color:#08CDF8;">1号机组</span>',
          '<span style="color:#08CDF8;">2号机组</span>',
          '<span style="color:#08CDF8;">3号机组</span>'
        ],
        data: [
          ['有功功率（MW）', '', '', ''],
          ['无功功率（MW）', '', '', ''],
          ['功率因数', '', '', ''],
          ['工作水头（m）', '', '', ''],
          ['流量（m³/s）', '', '', ''],
          ['周波（Hz）', '', '', ''],
          ['上游水位（m）', '', '', ''],
          ['下游水位（m）', '', '', '']
        ],
        align: ['center', 'center', 'center', 'center'],
        waitTime: 1000,
        headerHeight: 30,
        rowNum: 8,
        // columnWidth: [200],
        headerBGC: '#0c2e56',
        evenRowBGC: '#09223e',
        oddRowBGC: '#0c2e56'
      },
      propMap: [
        'activePower',
        'reactivePower',
        'powerFactor',
        'workingHead',
        'unitFlowRate',
        'cycle',
        'upstreamWaterLevel',
        'downstreamWaterLevel'
      ]
    }
  },
  methods: {
    setData(dataList) {
      this.propMap.forEach((item, index) => {
        for (let n = 1; n < 4; n++) {
          this.$set(this.config.data[index], n, dataList[n - 1][item].toFixed(2))
        }
      })
      let config = { ...this.config }
      this.config = config
    }
  }
}
</script>

<style scoped lang="scss">
.main-contain {
  height: 100%;
  width: 100%;
  .module-title {
    height: 14%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .table-box {
    width: 100%;
    height: 85%;
    padding: 0 15px 15px;
    .table {
      width: calc(100% - 30px);
      height: calc(100% - 15px);
    }
  }
}
</style>